import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { DatePickerField, EditFormContent, BaasicButton } from 'core/components';

function FacilityInventoryCountEditTemplate({ editView }) {
    const {
        form,
        title
    } = editView;
    return (
        <EditFormContent form={form}>
            <div className="modal__header">
                <h3 className='modal__header__title'>{title}</h3>
            </div>
            <div className="modal__body">
                <div className="form__group u-mar--top--med">
                    <DatePickerField field={form.$('countDate')} />
                </div>
            </div>
            <div className="modal__footer">
                <BaasicButton
                    type='submit'
                    className='btn btn--med u-push btn--primary'
                    label="Submit"
                    rotate
                    icon={
                        form.submitting || form.validating
                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                            : 'u-display--none'
                    }
                    disabled={form.submitting || form.validating}
                    onClick={form.onSubmit}
                />
            </div>
        </EditFormContent>
    )
}

FacilityInventoryCountEditTemplate.propTypes = {
    editView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityInventoryCountEditTemplate);
